if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.moveToIndex
) {
  Object.defineProperty(Array.prototype, 'moveToIndex', {
    value(value, newIndex) {
      const index = this.indexOf(value);
      if (newIndex > -1 && newIndex < this.length) this.splice(newIndex, 0, this.splice(index, 1)[0]);
      return this;
    }
  });
}